module.exports = __webpack_public_path__ + "media/images/rsp-logo-e8541e3c.png";